export type ButtonBoxType = 'default' | 'outline';

type ButtonBox = {
  type: ButtonBoxType;
  text: string;
  onClick: () => void;
  className?: string;
};

const ButtonBox = ({
  type = 'default',
  text,
  onClick,
  className,
}: ButtonBox) => {
  return (
    <button
      className={`flex items-center justify-center min-w-24 lg:min-w-40 px-4 py-5 border border-black ${type === 'outline' ? '' : 'bg-black text-white'} ${className || ''}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default ButtonBox;
